import type { Dictionary } from './dictionary';

/** Slovník EN – převzato z prototypu, doplněné klíče přeloženy ve stejném stylu. */
export const en: Dictionary = {
  app: 'Warehouse',
  logoutA: 'Log out',

  idLbl: 'Parcel number',
  seq: 'Stop no.',
  nav: 'Navigate',
  count: 'Parcels',
  weight: 'Weight',
  edit: 'Edit',
  date: 'Date',
  driver: 'Driver',
  vehicle: 'Vehicle',
  zone: 'Zone',
  routeNo: 'Route no.',
  deliveryTime: 'Time',
  scanned: 'Scanned code',
  scannedBy: 'Scanned by warehouse',
  noWeight: '— kg',
  addWeight: 'Add weight',

  until: 'Delivery only on',
  dayLbl: 'Delivery day',
  notSet: 'Not set yet',
  expedFrom: 'Will be dispatched from warehouse',

  chill: 'CHILLED',
  frozen: 'FROZEN',

  trCZ: 'SEND TO CZECHIA',
  trSK: 'SEND TO SLOVAKIA',
  trNoteCZ: 'The parcel must be transferred to Czechia.',
  trNoteSK: 'The parcel must be transferred to Slovakia.',
  loadToday: 'LOAD TODAY',
  confirmTr: 'Confirm transfer',
  trValCZ: 'Transferred to Czechia',
  trValSK: 'Transferred to Slovakia',
  confirmTitle: 'Confirm transfer between warehouses',
  confirmNote: 'Confirming writes to the order: “{W}”.',
  notFinal: 'Not a final state.',

  pkgLbl: 'Parcel',
  ofN: 'of',
  kompLbl: 'Order completion',
  kompDone: 'PARCEL FULLY SCANNED',
  kompTodo: 'STILL TO SCAN',

  retry: 'Repeat attempt',
  part: 'Deliver second part',

  scanNext: 'Scan next',
  report: 'REPORT TO DISPATCH',
  reported: 'Reported to dispatch',
  findManual: 'FIND MANUALLY',

  reportTitle: 'Report to dispatch',
  reasonLbl: 'Reason',
  byState: 'BY STATE',
  r_zrusena: 'Parcel is already cancelled',
  r_dorucena: 'Parcel is already delivered',
  r_vracena: 'Parcel is already returned to sender',
  r_jiny: 'Other reason – describe in the note',
  noteReq: 'Note (required)',
  noteOpt: 'Note (optional)',
  notePh: 'E.g. parcel damaged, label unreadable…',
  send: 'Send report',
  sending: 'Sending…',
  cancel: 'Cancel',
  errReason: 'Select a reason.',
  errNote: 'Add a note for the other reason.',

  findTitle: 'Find manually',
  orderNo: 'Order number',
  orderPh: 'Enter order number',
  search: 'Search',
  searching: 'Searching…',
  errQuery: 'Enter order number.',

  loginTitle: 'Sign in',
  loginSubtitle: 'Sign in to continue',
  loginName: 'Name',
  loginPin: 'PIN',
  loginSubmit: 'Sign in',
  loginPending: 'Signing in…',
  loginErrEmpty: 'Fill in name and PIN.',
  loginErrFailed: 'Sign-in failed.',

  scanTitle: 'Code scanning',
  scanHint: 'Point the camera at a QR or barcode.',
  scanStart: 'Start scanner',
  scanStop: 'Stop scanner',
  scanStarting: 'Starting camera…',
  scanCameraErr: 'Could not start the camera.',
  scanLoading: 'Loading parcel details…',
  manualTitle: 'Or enter the code manually',
  manualPh: 'Parcel number',
  manualSubmit: 'Find',

  errLoad: 'Could not load the parcel.',
  retryAction: 'Try again',
  offline: 'Offline – data may be out of date',
  queued: 'Will be sent once online',
  queueFailed: 'Could not be sent',
  sendErr: 'Could not be sent – try again',

  weightTitle: 'Weight correction',
  weightNew: 'New weight (kg)',
  weightPh: 'E.g. 15.5',
  weightPhotos: 'Photos (evidence)',
  weightHint: 'Enter the real weight and attach photos as evidence.',
  weightSave: 'Save weight',
  errWeight: 'Enter a valid weight.',

  routesEntry: 'Route overview',
  routesTitle: 'Routes',
  routeTitle: 'Route',
  routesLoading: 'Loading routes…',
  routesErr: 'Could not load the routes.',
  routesForbidden: 'You are not allowed to see the route overview.',
  routesEmpty: 'No routes for this day.',
  routesDay: 'Day',
  routesToday: 'Today',
  routesMine: 'My route',
  routesUnfinishedOnly: 'Unfinished only',
  routesAll: 'All',
  routesUnfinishedCount: 'Unfinished',
  routeShipments: 'Shipments',
  routeParcels: 'Parcels',
  routeLoaded: 'Loaded',
  routeScanned: 'Scanned',
  routeNoDriver: 'No driver',
  routeBack: 'Back to routes',
  routeErr: 'Could not load the route.',
  routeAllDone: 'The whole route is loaded.',
  routeToLoad: 'Left to load',
  routeUnseen: 'Not scanned',
  routeNoUnfinished: 'No unfinished shipment.',
  partialTitle: 'Partially scanned shipments',
  partialNoRoute: 'No route',
  partialLoading: 'Loading partially scanned shipments…',
  partialBack: 'Back to scanning',
  partialHint: 'Orders where only some parcels are scanned. Find the missing ones and scan them.',
  partialEmpty: 'No partially scanned shipment.',
  partialErr: 'Could not load partially scanned shipments.',
  shSender: 'Sender',
  'sh.loaded': 'LOADED',
  'sh.notLoaded': 'SCANNED, NOT LOADED',
  'sh.incomplete': 'NOT FULLY SCANNED, NOT LOADED',
  'sh.unknown': 'UNKNOWN STATE',
  shMissing: 'Missing parcels',

  's.preprava.kicker': 'All good',
  's.preprava.name': 'In transit',
  's.preprava.headline': '',
  's.preprava.sub': 'The parcel is in transit as planned.',

  's.schvaleni.kicker': 'Awaiting approval',
  's.schvaleni.name': 'Transport approval',
  's.schvaleni.headline': 'NOT SHIPPING TOMORROW',
  's.schvaleni.sub':
    'Transport is not approved, the parcel has no confirmed delivery day yet. Do not put the parcel on tomorrow’s route.',

  's.priprava.kicker': 'In progress · preparing',
  's.priprava.name': 'Parcel preparation',
  's.priprava.headline': '',
  's.priprava.sub': 'The parcel is not shipping tomorrow, delivery is expected later.',

  's.vraceni.kicker': 'Ships later · returning',
  's.vraceni.name': 'Return to sender',
  's.vraceni.headline': '',
  's.vraceni.sub':
    'The parcel is not shipping tomorrow, delivery is expected later. Not a final state.',

  's.dokoncena.kicker': 'Final state · report to dispatch',
  's.dokoncena.name': 'Completed',
  's.dokoncena.headline': 'PARCEL ERROR',
  's.dokoncena.sub': 'The order is already in a final state – report it to dispatch.',

  's.zrusena.kicker': 'Final state · report to dispatch',
  's.zrusena.name': 'Cancelled',
  's.zrusena.headline': 'PARCEL ERROR',
  's.zrusena.sub': 'The order is already in a final state – report it to dispatch.',

  's.vraceno.kicker': 'Final state · report to dispatch',
  's.vraceno.name': 'Returned to sender',
  's.vraceno.headline': 'PARCEL ERROR',
  's.vraceno.sub': 'The order is already in a final state – report it to dispatch.',

  's.nenalezena.kicker': 'Code not in system',
  's.nenalezena.name': 'Parcel not found',
  's.nenalezena.headline': 'PARCEL NOT FOUND',
  's.nenalezena.sub': 'The scanned code was not found in the system.',

  's.neznamy.kicker': 'Unrecognised · verify',
  's.neznamy.name': 'Unknown state',
  's.neznamy.headline': '',
  's.neznamy.sub': 'The app does not recognise this state. Do not continue without checking with dispatch.',
};
